import styled from 'styled-components';

export const ContentSettingsTabs = styled('div')`
  display: flex;
  margin: 1rem 0;
  justify-content: space-around;
`;

export const ContentSettingsContainer = styled('div')`
  flex: 1;
  display: flex;
  overflow: auto;
  overflow: overlay;
  flex-direction: column;
`;
